const regExp = {
    name: /^(?=.*[a-zA-Z])(?!(?:\d+)$)[a-zA-Z0-9 .&@()'-]+$/,
    email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    // pswd: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&/;:.,#])[A-Za-z\d@$!%*?&/;:.,<=>{+}[`~#^()_-|'"\]\\]{8,}$/,
    //pswd:  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d+\-*/.@$!%?&:;,<=>{}[\]()`~#^_|'"\\]{8,}$/,
    // pswd: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[*,?,{,},\[,\],;!@$&]).{8,}$/,
    pswd:/^(?=.*[A-Za-z])(?=.*\d)\S{8,}$/,
    company_name: /^[A-Za-zÀ-ÖØ-öø-ÿ0-9][A-Za-zÀ-ÖØ-öø-ÿ0-9 .,&'’()\/!@-]*$/,
    website_url: /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/,
    pincode: /^[a-zA-Z0-9]{4,10}$/,
    iecNumber: /^[0-9]{10}$/,
    product_name: /^(?=.*[a-zA-Z])(?!(?:\d+)$)[a-zA-Z0-9- .&@]+$/,
    bill_number: /^[A-Za-z0-9-/()]{1,10}$/,
    quantity: /^\d*(\.)?(\d{0,2})?$/,
    //designation: /^[A-Za-z][A-Za-z0-9 ,&.-/]*$/,
    designation: /^[A-Za-z](?:[A-Za-z0-9 ,&.-/]*[A-Za-z0-9])?(?:\s*[-&/]\s*[A-Za-z0-9]+)*(?:\s*)?$/,
    videoLink: /^(https?:\/\/)?([a-zA-Z0-9-\.]+)\.([a-zA-Z]{2,})(:\d+)?(\/[^\s]*)?$/,
    certificate_name: /^[a-zA-Z0-9_()/., -]+$/,
    natural_number: /^\d*[1-9]+\d*$/, //witout zero
    otherCertificate: /^[A-Za-z][A-Za-z0-9 ,&().\/\-]*[A-Za-z0-9)]$/,
    role_slug: /^(?!.*__)[A-Z]+(?:_[A-Z]+)*$/,
    role_name: /^(?!\d+$)[A-Za-z0-9/&\- ]+$/,
    // port_name: /^(?=.*[a-zA-Z])[a-zA-Z0-9\s\-\/'.()&]+(\([a-zA-Z0-9\s\-\/'.&]*\))?[a-zA-Z0-9\s\-\/'.()&]*$/,
    port_name: /^(?=.*[a-zA-ZÀ-ž])[a-zA-ZÀ-ž0-9\s\-\/'.()&]+(\([a-zA-ZÀ-ž0-9\s\-\/'.&]*\))?[a-zA-ZÀ-ž0-9\s\-\/'.()&]*$/,
    inquiry: {
        product: /^(?=.*[a-zA-Z])[a-zA-Z0-9\s\-\'.\(\)&]+(\([a-zA-Z0-9\s\-\'.\&]*\))?[a-zA-Z0-9\s\-\'.\(\)&]*$/,
        quantity: /^(?!0(\.0+)?$)(\d+(\.\d+)?|\.\d+)$/,
        unit: /^[a-zA-Z]+(\s*[-&]?\s*[a-zA-Z]+)*(\s*\(\s*[a-zA-Z]+\s*\))?$/,
        no_of_containers: /^(?!0(\0+)?$)(\d+(\d+)?|\d+)$/,
        lwh: /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9\s\-\'.\(\)&]+(\([a-zA-Z0-9\s\-\'.\&]*\))?[a-zA-Z0-9\s\-\'.\(\)&]*$/,
        commodity: /^(?=.*[a-zA-Z])[a-zA-Z0-9\s\-\'.\(\)&]+(\([a-zA-Z0-9\s\-\'.\&]*\))?[a-zA-Z0-9\s\-\'.\(\)&]*$/,
        cbpp: /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9\s\-\'.\(\)&]+(\([a-zA-Z0-9\s\-\'.\&]*\))?[a-zA-Z0-9\s\-\'.\(\)&]*$/,
        total_weight: /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9\s\-\'.\(\)&]+(\([a-zA-Z0-9\s\-\'.\&]*\))?[a-zA-Z0-9\s\-\'.\(\)&]*$/,

    }


}

export default regExp;